import { computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useSurveyStore } from "../survey";
import { isEmpty } from "@utils/toolBox";

export const useSurveyTitleStore = defineStore("surveyTitle", () => {
  // imported stores
  const surveyStore = useSurveyStore();
  const { survey } = storeToRefs(surveyStore);

  const currentSurveyTitle = computed(() => survey.value?.name);
  const updateSurveyTitle = (value) => (survey.value.name = value);

  const isTitleEmpty = computed(() => isEmpty(currentSurveyTitle.value));

  return {
    currentSurveyTitle,
    updateSurveyTitle,
    isTitleEmpty,
  };
});
